// extracted by mini-css-extract-plugin
export default {"fab":"FloatingWhatsApp_fab__S7FEI","pulse":"FloatingWhatsApp_pulse__fR0cb","icon":"FloatingWhatsApp_icon__otPex"};